import { Butterfly } from './butterfly-icon';

/** Общий знак продукта и бумажная иллюстрация для входа и гостевых страниц. */
export function ButterflyBrand() {
  return <div className="butterfly-brand"><span className="butterfly-brand__mark"><Butterfly size={24} /></span><span>Ожившие бабочки<small>Творчество оживает</small></span></div>;
}

export function ButterflyGardenArt() {
  return <div className="butterfly-garden-art" aria-hidden="true">
    <span className="butterfly-garden-art__sun" />
    <span className="butterfly-garden-art__hill butterfly-garden-art__hill--back" />
    <span className="butterfly-garden-art__hill" />
    <img className="butterfly-garden-art__orange" src="/butterflies/presets/classic-orange.png" alt="" />
    <img className="butterfly-garden-art__pink" src="/butterflies/presets/moth-pink.png" alt="" />
    <span className="butterfly-garden-art__caption"><Butterfly size={15} /> Из рисунка — в маленькое чудо</span>
  </div>;
}
